/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portals_Org_EmptyInputs */

const cs_portals_org_empty = /** @type {(inputs: Portals_Org_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zatím žádné exporty na portály.`)
};

const en_portals_org_empty = /** @type {(inputs: Portals_Org_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No portal export rows yet.`)
};

/**
* | output |
* | --- |
* | "No portal export rows yet." |
*
* @param {Portals_Org_EmptyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const portals_org_empty = /** @type {((inputs?: Portals_Org_EmptyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portals_Org_EmptyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_portals_org_empty(inputs)
	return cs_portals_org_empty(inputs)
});